export default __webpack_public_path__ + "static/media/HEC.f9386df3.png";